export const requiredFormFields = [
  '00N0D000001Nf3r',
  '00N0D000001Nf3s',
  '00N2p000009F91p',
  '00N2p000009F918',
  'agreementForMarketingCommunicationByEmail',
  'company',
  'countryCode',
  'email',
  'firstName',
  'industry',
  'jobTitle',
  'lastName',
  'phone-input',
  'postalCode',
  'product',
  'countryCode',
  'subject',
  'stateCode',
  'zipCode',
]
